document.addEventListener('DOMContentLoaded', function() {
    // 1. Seleziona l'elemento cliccabile usando il selettore specifico
    const closeButton = document.querySelector('.custom-thb-search-close');
    const search_box = document.querySelector('.thb-quick-search--results');
    // 2. Seleziona l'elemento di input da svuotare
    const searchInput = document.querySelector('.search-desktop  .search-field');

    // 3. Controlla che entrambi gli elementi esistano nella pagina per evitare errori
    if (closeButton && searchInput) {

    // 4. Aggiungi un "ascoltatore" che attende un click sul pulsante
    closeButton.addEventListener('click', function() {
        
        // 5. Quando avviene il click, svuota il campo di input
        search_box.classList.remove('active');
        searchInput.focus();
        searchInput.value = '';
    });
    } else {
    // Messaggio di errore aggiornato per un debug più facile
    if (!closeButton) {
        console.error("Errore: Impossibile trovare l'elemento ' .custom-thb-search-close'.");
    }
    if (!searchInput) {
        console.error("Errore: Impossibile trovare l'elemento '.search-field'.");
    }
    }
});
/* CONFEZIONE REGALO */
/*document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('gift-wrapping') || null;
  if (checkbox != null){
    // Cambia questo ID con l'ID della variante del tuo prodotto "Confezione Regalo"
    const giftWrapVariantId = '56023637262711'; // <-- METTI IL TUO ID VARIANTE QUI

    // Controlla lo stato iniziale del carrello
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const isGiftWrapInCart = cart.items.some(item => item.variant_id == giftWrapVariantId);
        checkbox.checked = isGiftWrapInCart;
      });

    // Aggiungi l'evento al click
    checkbox.addEventListener('change', function() {
      let formData = {};
      
      if (checkbox.checked) {
        // Aggiungi al carrello
        formData = {
        'items': [{
          'id': giftWrapVariantId,
          'quantity': 1
        }]
        };
      } else {
        // Rimuovi dal carrello
        formData = {
        'updates': {
          [giftWrapVariantId]: 0
        }
        };
      }

      // Invia la richiesta all'API Cart
      fetch( '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        // Ricarica la pagina del carrello o aggiorna la sezione per vedere le modifiche
        // Per i carrelli a cassetto, potresti dover richiamare una funzione JS specifica del tema
        location.reload(); 
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }

});*/